import { ErrorHandler, Injectable } from '@angular/core';
import { RemoteLoggerService } from './services/remote-logger.service';

@Injectable()
export class AppErrorHandler implements ErrorHandler {
  constructor(private logger: RemoteLoggerService) {}

  handleError(e: Error) {
    this.logger.capture(e);
  }
}
